import { SearchObject } from "app/common/Model/SearchObject";
import { reportVoucherExpense } from "app/services/ReportService";
import { exportVoucherReportExpense } from "app/services/VoucherService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
export default class ReportExpenseStore {
  listDataExpense = null;
  searchReportExpense = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    staffId: null,
    listDepId: [],
  };
  constructor() {
    makeAutoObservable(this);
  }

  handleChangeFormSearchExpense = (searchReportExpense) => {
    this.searchReportExpense = {
      ...this.searchReportExpense,
      ...searchReportExpense,
    };
    this.pagingReportExpense();
  };

  pagingReportExpense = async () => {
    // Không call API nếu không có cơ sở (bắt buộc)
    if (!this.searchReportExpense.listDepId || this.searchReportExpense.listDepId.length === 0) {
      this.listDataExpense = null;
      return;
    }
    
    let search = this.normalizeSearchReportVoucher(this.searchReportExpense);

    return await reportVoucherExpense({ ...search })
      .then(({ data }) => {
        this.listDataExpense = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu báo cáo khoản chi cơ sở có lỗi");
      });
  };

  handleExportExpenseReport = async (searchObj) => {
    if (!(searchObj?.listDepId?.length > 0)) {
      toast.error("Vui lòng chọn cơ sở để xuất excel");
      return;
    }
    const search = this.normalizeSearchReportVoucher(searchObj);
    try {
      const response = await exportVoucherReportExpense(search);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "BC_CHI_THEO_CO_SO.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };

  normalizeSearchReportVoucher = (rawSearch = {}) => {
    const { staffId, listDepId, ...rest } = rawSearch;
    return {
      ...rest,
      staffId: staffId?.id || null,
      listDepId: listDepId?.map((el) => el?.id),
    };
  };

  resetStore = () => {
    this.listData = null;
    this.searchFee = {
      ...new SearchObject(),
      fromDate: new Date(),
      toDate: new Date(),
    };
  };
}
